// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/Mask Group 16.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
    position: relative;
    height: 692px;
    padding-inline: 85px;
    padding-top: 140px;
    background-color: #ffffff;
}

.hero::before {
    content: "";
    position: absolute;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
    opacity: 0.18;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
}

.hero .col-5{
    padding: 0 !important;
    display: flex;
    justify-content: flex-end;
}

.hero .intro h1 {
    color: #060D27;
    font-size: 48px;
    font-weight: 600;
    margin-bottom: 15px;
}

.hero .intro h2 {
    font-size: 18px;
    margin-bottom: 50px;
    font-weight: 400;
    letter-spacing: 0.5px;
}

.hero .path {
    position: absolute;
    top: 275px;
    left: 120px;
    height: 70px;
}

.hero span {
    font-size: 24px;
    margin-left: 5px;
    font-weight: 500;
}

.hero .intro p {
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 10px;
}

.hero .intro .btn {
    background-color: #F7D600;
    border: none;
    border-radius: 15px;
    font-weight: 600;
    color: #2A2F5C;
    padding: 0px 15px;
}

.payments {
    width: 471px;
    height: 500px;
    background-color: #FAFBFF;
    box-shadow: 0px 3px 20px #060D274D;
    border-radius: 15px;
    padding: 30px 25px;
}

.service {
    background-color: #ffffff;
    width: 124px;
    height: 137px;
    box-shadow: 0px 2px 10px #00000029;
    border-radius: 15px;
    padding: 15px 30px;
}

.service-img {
    height: 50px;
    width: 50px;
    margin-left: 10px;
    margin-bottom: 20px;
}

.pos {
    position: absolute;
    top: 220px;
    left: 135px;
    height: 650px;
    width: 650px;
}

.arrow-img {
    position: absolute;
    top: 190px;
    left: 120px;
    width: 65px;
    animation: arrow 3s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
}

.pos-img {
    height: 650px;
    width: 700px;
    animation: floating 3s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
}

.app-download {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}

.app-download p {
    font-size: 12px;
    color: #808080;
}

.app-download span {
    font-size: 12px;
    color: #060D27;
}

.app-download .download-links {
    display: flex;
    gap: 15px;
    justify-content: center;
    align-items: center;
}

.download-app {
    height: 50px;
    width: 160px;
}




@keyframes floating {
    0% {transform: translate(0px, 0px);}
    50% {transform: translate(30px, 30px);}
    100% {transform: translate(0px, -0px);}
}

@keyframes arrow {

    0% {transition: width; width: 65px;}
    50% {width: 105px;}
    100% {width: 65px;}
}`, "",{"version":3,"sources":["webpack://./src/view/landing/HeroSection.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yDAAgE;IAChE,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;IACb,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,sCAAsC;IACtC,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,sCAAsC;IACtC,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;;;;AAKA;IACI,IAAI,8BAA8B,CAAC;IACnC,KAAK,gCAAgC,CAAC;IACtC,MAAM,+BAA+B,CAAC;AAC1C;;AAEA;;IAEI,IAAI,iBAAiB,EAAE,WAAW,CAAC;IACnC,KAAK,YAAY,CAAC;IAClB,MAAM,WAAW,CAAC;AACtB","sourcesContent":[".hero {\n    position: relative;\n    height: 692px;\n    padding-inline: 85px;\n    padding-top: 140px;\n    background-color: #ffffff;\n}\n\n.hero::before {\n    content: \"\";\n    position: absolute;\n    background-image: url(\"../../assets/images/Mask\\ Group\\ 16.png\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    opacity: 0.18;\n    top: 0px;\n    right: 0px;\n    bottom: 0px;\n    left: 0px;\n}\n\n.hero .col-5{\n    padding: 0 !important;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.hero .intro h1 {\n    color: #060D27;\n    font-size: 48px;\n    font-weight: 600;\n    margin-bottom: 15px;\n}\n\n.hero .intro h2 {\n    font-size: 18px;\n    margin-bottom: 50px;\n    font-weight: 400;\n    letter-spacing: 0.5px;\n}\n\n.hero .path {\n    position: absolute;\n    top: 275px;\n    left: 120px;\n    height: 70px;\n}\n\n.hero span {\n    font-size: 24px;\n    margin-left: 5px;\n    font-weight: 500;\n}\n\n.hero .intro p {\n    font-weight: 500;\n    font-size: 18px;\n    margin-bottom: 10px;\n}\n\n.hero .intro .btn {\n    background-color: #F7D600;\n    border: none;\n    border-radius: 15px;\n    font-weight: 600;\n    color: #2A2F5C;\n    padding: 0px 15px;\n}\n\n.payments {\n    width: 471px;\n    height: 500px;\n    background-color: #FAFBFF;\n    box-shadow: 0px 3px 20px #060D274D;\n    border-radius: 15px;\n    padding: 30px 25px;\n}\n\n.service {\n    background-color: #ffffff;\n    width: 124px;\n    height: 137px;\n    box-shadow: 0px 2px 10px #00000029;\n    border-radius: 15px;\n    padding: 15px 30px;\n}\n\n.service-img {\n    height: 50px;\n    width: 50px;\n    margin-left: 10px;\n    margin-bottom: 20px;\n}\n\n.pos {\n    position: absolute;\n    top: 220px;\n    left: 135px;\n    height: 650px;\n    width: 650px;\n}\n\n.arrow-img {\n    position: absolute;\n    top: 190px;\n    left: 120px;\n    width: 65px;\n    animation: arrow 3s;\n    animation-timing-function: ease-in-out;\n    animation-iteration-count: infinite;\n}\n\n.pos-img {\n    height: 650px;\n    width: 700px;\n    animation: floating 3s;\n    animation-timing-function: ease-in-out;\n    animation-iteration-count: infinite;\n}\n\n.app-download {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-top: 15px;\n}\n\n.app-download p {\n    font-size: 12px;\n    color: #808080;\n}\n\n.app-download span {\n    font-size: 12px;\n    color: #060D27;\n}\n\n.app-download .download-links {\n    display: flex;\n    gap: 15px;\n    justify-content: center;\n    align-items: center;\n}\n\n.download-app {\n    height: 50px;\n    width: 160px;\n}\n\n\n\n\n@keyframes floating {\n    0% {transform: translate(0px, 0px);}\n    50% {transform: translate(30px, 30px);}\n    100% {transform: translate(0px, -0px);}\n}\n\n@keyframes arrow {\n\n    0% {transition: width; width: 65px;}\n    50% {width: 105px;}\n    100% {width: 65px;}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
